import { faRepeatAlt } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";

import { ProductCardBadgePrice, ProductCardBadge } from "../types";
import { badgeLabel } from "../utils";

type ProductCardBadgesProps = {
  badges: ProductCardBadge[];
  styles: Record<string, string>;
  maxBadges?: number;
};

// What the row fits on one line.
const MAX_BADGES = 2;

/** The default item's savings badges; renders nothing when the item has none. */
const ProductCardBadges = ({ badges, styles, maxBadges = MAX_BADGES }: ProductCardBadgesProps) => {
  if (!badges.length) {
    return null;
  }
  return (
    <div className={styles.badgeRow}>
      {badges.slice(0, maxBadges).map((badge) => (
        <span
          key={`${badge.source}-${badge.promotion_id}-${badge.applies_to}`}
          className={styles.savingsBadge}
        >
          {/* Titled, since the icon is the only thing marking the saving as autoship-only. */}
          {badge.applies_to === ProductCardBadgePrice.Subscription && (
            <Icon icon={faRepeatAlt} title="Autoship" />
          )}
          {badgeLabel(badge)}
          {!!badge.promo_code && <span className={styles.promoCode}>{badge.promo_code}</span>}
        </span>
      ))}
    </div>
  );
};

export default ProductCardBadges;
